export default {
  // Index
  notifications: {
    english: "Notifications",
    spanish: "Notificaciones",
  },
};
